// based on https://github.com/kimuraz/vue-rest/blob/dev/index.js

import Vue from 'vue';
import axios from 'axios';

const VueApi = {
	install(Vue, options) {
		if (Vue.vueApi) return;
		Vue.vueApi = true;

		let api = null;
		if (options && options.axiosOptions) {
			api = axios.create(options.axiosOptions);

			if (options.axiosOptions.localStorageAuthorization) {

				const localStorageAuthorization = options.axiosOptions.localStorageAuthorization;

				api.interceptors.request.use((config) => {
					const token = localStorage.getItem(localStorageAuthorization.tokenItem);
					const prefix = localStorageAuthorization.prefix;

					if (!localStorageAuthorization.tokenItem || !prefix) {
						console.error('[ERR - VueApi]: Miss configuration at localStorageAuthorization.');
					}

					if (token) {
						Object.assign(config.headers, { Authorization: `${prefix} ${token}` });
					}

					return config;
				});
			}
		}

		if (!api) {
			api = axios.create();
		}

		Vue.api = api;
		Vue.prototype.$api = api;
	},
};

export default VueApi;



// WEBPACK FOOTER //
// ./src/VueApi.js